import { jsx as e, jsxs as l, Fragment as h } from "react/jsx-runtime";
import { Popover as u, Tooltip as b, FormSelectInline as f } from "@systemeio/ui";
import { useEditorState as I } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as N, useMemo as E } from "react";
import { twMerge as y, twJoin as v } from "tailwind-merge";
import { ToolbarSelectButton as g } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as w } from "../../constants/default-styles.mjs";
import { specialCharactersData as i } from "./special-characters-data.mjs";
import { SelectedCategoriesEnum as T } from "./selected-categories-enum.mjs";
import C from "../../icons/special-characters.mjs";
import { getCharactersCategoriesData as S } from "./get-characters-categories-data.mjs";
import { useTranslation as j } from "../../i18n.mjs";
const J = (c) => {
  const { t: r } = j(), [t, x] = N(T.All), [o, m] = N(null), d = I({
    editor: c,
    selector: ({ editor: n }) => ({
      isEditable: (n == null ? void 0 : n.options.editable) ?? !1
    })
  }), s = !(d != null && d.isEditable);
  return E(() => {
    const n = (a) => {
      if (!c) return null;
      c.chain().focus().insertContent(a).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ e(
        u,
        {
          className: y("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: s,
          anchor: "bottom",
          label: /* @__PURE__ */ l("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: r("special_characters.title") }),
                  /* @__PURE__ */ e(
                    f,
                    {
                      optionsClassName: "z-50",
                      onChange: (a) => a && x(a),
                      value: t,
                      data: S(r),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: i[t].map((a, p) => /* @__PURE__ */ e(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => n(a.symbol),
                onMouseEnter: () => m(p),
                onMouseLeave: () => m(null),
                children: /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: a.symbol })
              },
              a.code
            )) }),
            /* @__PURE__ */ e("div", { className: "mt-3 flex h-5 items-center justify-between", children: o !== null && /* @__PURE__ */ l(h, { children: [
              /* @__PURE__ */ e("span", { className: "text-xs", children: r(i[t][o].name) }),
              " ",
              /* @__PURE__ */ e("span", { className: "text-xs", children: i[t][o].code })
            ] }) })
          ] }),
          children: (a) => /* @__PURE__ */ e(
            b,
            {
              disabled: s,
              label: r("special_characters.title"),
              anchor: "left",
              ...w,
              children: /* @__PURE__ */ e(g, { disabled: s, open: a, children: /* @__PURE__ */ e(
                C,
                {
                  className: v(
                    s ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                    "main-transition-colors"
                  )
                }
              ) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ e(
        u,
        {
          className: y("group"),
          popoverClassName: "bg-background-secondary rounded-lg shadow-around-sm z-40 transition duration-200 ease-out",
          disabled: s,
          anchor: "bottom",
          label: /* @__PURE__ */ l("div", { className: "max-w-[280px] lg:max-w-[320px]", children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: "border-text-secondary/30 flex items-center justify-between border-b pb-2",
                children: [
                  /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: r("special_characters.title") }),
                  /* @__PURE__ */ e(
                    f,
                    {
                      optionsClassName: "z-50",
                      onChange: (a) => a && x(a),
                      value: t,
                      data: S(r),
                      withoutCloseIcon: !0,
                      captionClassName: "no-underline"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e("div", { className: "customScroll flex max-h-[180px] flex-wrap gap-2 overflow-auto py-3", children: i[t].map((a, p) => /* @__PURE__ */ e(
              "div",
              {
                className: "hover:border-brand-primary main-transition-colors h-[26px] w-[26px] cursor-pointer rounded-sm text-center",
                onClick: () => n(a.symbol),
                onMouseEnter: () => m(p),
                onMouseLeave: () => m(null),
                children: /* @__PURE__ */ e("span", { className: "text-text-primary text-base", children: a.symbol })
              },
              a.code
            )) }),
            /* @__PURE__ */ e("div", { className: "mt-3 flex h-5 items-center justify-between", children: o !== null && /* @__PURE__ */ l(h, { children: [
              /* @__PURE__ */ e("span", { className: "text-xs", children: r(i[t][o].name) }),
              " ",
              /* @__PURE__ */ e("span", { className: "text-xs", children: i[t][o].code })
            ] }) })
          ] }),
          children: (a) => /* @__PURE__ */ e(
            b,
            {
              disabled: s,
              label: r("special_characters.title"),
              anchor: "left",
              ...w,
              children: /* @__PURE__ */ l(g, { className: "flex gap-1", disabled: s, open: a, children: [
                /* @__PURE__ */ e(
                  C,
                  {
                    className: v(
                      s ? "fill-text-secondary" : "fill-text-primary group-hover:fill-brand-primary",
                      "main-transition-colors"
                    )
                  }
                ),
                r("special_characters.title")
              ] })
            }
          )
        }
      )
    };
  }, [c, o, s, t, r]);
};
export {
  J as useSpecialCharactersExtensionToolbar
};
